import React, { useEffect, useState, Suspense, useMemo } from 'react';
import { createStackNavigator, TransitionPresets } from '@react-navigation/stack';
import { routes } from './routes';
import { WELCOME_SCREEN, HOME_PAGE } from './routes';
import { useSelector, shallowEqual } from 'react-redux';
import { LANDSCAPE } from '../../config/Constant';

const Stack = createStackNavigator();

export const HomeNavigator = () => {
  const { appOrientation } = useSelector(state => (state.appConfigSlice));
  // Combine selectors to reduce re-renders
  const { webAppWidgetsInfo, isLoggedIn, shownWelcomeScreen, isBookingFound } = useSelector(
    state => ({
      webAppWidgetsInfo: state.deviceConfigSlice.webAppWidgetsInfo,
      isLoggedIn: state.appConfigSlice.isLoggedIn,
      shownWelcomeScreen: state.appConfigSlice.shownWelcomeScreen,
      isBookingFound: state.checkInSlice.bookingStatus.isBookingFound,
    }),
    shallowEqual
  );

  const screenInfoAfterLoader = webAppWidgetsInfo?.screenInfoAfterLoader;

  const [initialRoute, setInitialRoute] = useState(null);

  const checkShowWelcomeScreen = () => {
    try {

      if (screenInfoAfterLoader?.showAfterScreen && !shownWelcomeScreen) {

        if ((isLoggedIn || isBookingFound) && screenInfoAfterLoader.showAfterLogin) {
          setInitialRoute(WELCOME_SCREEN);
          return;
        }

        if (!isLoggedIn && !isBookingFound) {
          setInitialRoute(WELCOME_SCREEN);
          return;
        }
      }

      setInitialRoute(HOME_PAGE)
    } catch (error) {
      setInitialRoute(HOME_PAGE)
      console.error('Error checking welcome screen display:', error);
    }
  };

  useEffect(() => {
    checkShowWelcomeScreen();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  // Render a loading view until initialRoute is set
  if (initialRoute === null) {
    return null; // Or a loading spinner, or a temporary screen
  }

  const navigator = (
    <Stack.Navigator
      key={`stack-${appOrientation}`}
      screenOptions={{
        headerShown: false,
        cardStyle: { flex: 1 },
        ...(appOrientation == LANDSCAPE ? {} : TransitionPresets.SlideFromRightIOS),
        animation: appOrientation==LANDSCAPE ? 'none' : 'default',
        detachPreviousScreen: false,
      }}
      initialRouteName={initialRoute}
    >
      {routes.map((iterator) => (
        <Stack.Screen
          key={iterator.name}
          name={iterator.name}
          component={iterator.component}
          options={iterator.options}
        />
      ))}
    </Stack.Navigator>
  );

  return navigator;
};
